window.o_global = window.o_global || {};
window.o_global.pali = window.o_global.pali || {};

window.o_global.pali.slider = function () {
  class Slider {
    constructor(options = {}) {
      // Position will be between 0 und maxPos e.g. 100 steps to reach maxLogVal
      this.minPos = 0;
      this.maxPos = options.maxPos || 100;
      this.minVal = +options.minVal;
      this.maxVal = +options.maxVal;

      this.logarithmic = options.logarithmic;
      // The result should be between minLogVal and maxLogVal e.g. 1 and 5000
      // Math.log(0) = NaN, Math.exp(-1) = 0
      this.minLogVal = this.minVal === 0 ? -1 : Math.log(this.minVal || 0);
      this.maxLogVal = Math.log(this.maxVal || 5000);

      // Calculate adjustment factor
      this.logScale = (this.maxLogVal - this.minLogVal) / this.maxPos;
      this.linScale = (this.maxVal - this.minVal) / this.maxPos;
    }

    /**
     * Calculate linear value from slider position
     * @param {number} pos
     * @return {number}
     */
    calcLinValue(pos) {
      return pos * this.linScale + this.minVal;
    }

    /**
     * Calculate linear position from a input value
     * @param {number} val
     * @returns {number}
     */
    calcLinPosition(val) {
      return (val - this.minVal) / this.linScale;
    }

    /**
     * Calculate log value from slider position
     * @param {number} position
     * @returns {number}
     */
    calcLogValue(position) {
      return Math.exp(position * this.logScale + this.minLogVal);
    }

    /**
     * Calculate log slider position from a value
     * @param {number} value
     * @returns {number}
     */
    calcLogPosition(value) {
      return value === 0 ? 0 : (Math.log(value) - this.minLogVal) / this.logScale;
    }
  }

  /* eslint-disable no-param-reassign */
  const init = function (selector) {
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    const defaultSettings = {
      minLabel: "Von", // String: Label text for the min input field.
      maxLabel: "Bis", // String: Label text for the max input field.
      inputPrefixIcon: null, // String: Optional svg icon displayed at the start of the input field.
      inputPrefixText: null, // String: Optional text displayed at the start of the input field.
      inputSuffixIcon: null, // String: Optional svg icon displayed at the end of the input field.
      inputSuffixText: null, // String: Optional text displayed at the end of the input field.
      maxPos: 100, // Number: Determines how many steps are between min and max position.
      minVal: 0, // Number: The minimum value.
      maxVal: 100, // Number: The maximum value.
      logarithmic: false, // Boolean: Whether the sliders scala is based on a logarithmic function (default is linear).
    };

    const settingsMap = {
      minLabel: "data-slider-min-label",
      maxLabel: "data-slider-max-label",
      inputPrefixIcon: "data-slider-input-prefix-icon",
      inputPrefixText: "data-slider-input-prefix-text",
      inputSuffixIcon: "data-slider-input-suffix-icon",
      inputSuffixText: "data-slider-input-suffix-text",
      maxPos: "data-slider-max-pos",
      minVal: "data-slider-min-val",
      maxVal: "data-slider-max-val",
      logarithmic: "data-slider-logarithmic",
    };

    let settings = {};

    /**
     * @param {HTMLElement} element
     * @returns {Object}
     */
    const parseDataAttributes = (element) => {
      const parsedSettings = {};

      Object.keys(settingsMap).forEach((key) => {
        const attribute = element.getAttribute(settingsMap[key]);

        if (attribute) {
          let parsedAttribute = null;

          // Change strings to data-types.
          switch (attribute) {
            case "false":
              parsedAttribute = false;
              break;
            case "true":
              parsedAttribute = true;
              break;
            case "null":
              parsedAttribute = null;
              break;
            default:
              parsedAttribute = attribute;
          }

          parsedSettings[key] = parsedAttribute;
        }
      });

      return parsedSettings;
    };

    /**
     * @param {HTMLDivElement} sliderContainer
     */
    function setup(sliderContainer) {
      // Initialise Slider instance
      const slider = new Slider({
        maxPos: settings.maxPos,
        minVal: settings.minVal,
        maxVal: settings.maxVal,
        logarithmic: settings.logarithmic,
      });

      // Number input: Create DOM elements
      const numberInputWrapper = document.createElement("div");

      const numberInputMinContainer = document.createElement("div");
      const numberInputMin = document.createElement("input");
      const numberInputMinLabel = document.createElement("label");

      const numberInputMaxContainer = document.createElement("div");
      const numberInputMax = document.createElement("input");
      const numberInputMaxLabel = document.createElement("label");

      // Number input: Set CSS classes for elements
      numberInputWrapper.classList.add("pl_slider__input-wrapper");

      numberInputMinContainer.classList.add("pl_input", "js-pl_input");
      numberInputMin.classList.add("pl_input__field");
      numberInputMinLabel.classList.add("pl_label", "js-pl_label");

      numberInputMaxContainer.classList.add("pl_input", "js-pl_input");
      numberInputMax.classList.add("pl_input__field");
      numberInputMaxLabel.classList.add("pl_label", "js-pl_label");

      // Number input: Set attributes for elements
      numberInputMin.setAttribute("type", "number");
      numberInputMinLabel.innerText = settings.minLabel;

      numberInputMax.setAttribute("type", "number");
      numberInputMaxLabel.innerText = settings.maxLabel;

      // Number input: Set values for HTML input elements from Slider instance
      numberInputMin.min = slider.minVal;
      numberInputMin.max = slider.maxVal;
      numberInputMin.value = slider.minVal;

      numberInputMax.min = slider.minVal;
      numberInputMax.max = slider.maxVal;
      numberInputMax.value = slider.maxVal;

      // Number input: Append the elements
      numberInputMinContainer.appendChild(numberInputMin);
      numberInputMinContainer.appendChild(numberInputMinLabel);

      numberInputMaxContainer.appendChild(numberInputMax);
      numberInputMaxContainer.appendChild(numberInputMaxLabel);

      const buildPrefixElement = () => {
        /**
         * @type {HTMLElement} prefix
         */
        let prefix;

        /**
         * @type {string} prefixIcon
         */
        const prefixIcon = settings.inputPrefixIcon
          ? settings.inputPrefixIcon.match(/^pl_icon_.*/)[0]
          : null;

        /**
         * @type {string} prefixText
         */
        const prefixText = settings.inputPrefixText;

        if (prefixIcon) {
          prefix = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          prefix.classList.add("pl_icon", "pl_input__prefix");
          prefix.setAttribute("role", "img");
          prefix.innerHTML = `<use xlink:href="/assets-static/icons/${prefixIcon}.svg#${prefixIcon}"></use>`;
        } else if (prefixText) {
          prefix = document.createElement("small");
          prefix.classList.add("pl_input__note", "pl_input__suffix");
          prefix.innerText = prefixText;
        }

        return prefix;
      };

      const buildSuffixElement = () => {
        /**
         * @type {HTMLElement} prefix
         */
        let suffix;

        /**
         * @type {string} suffixIcon
         */
        const suffixIcon = settings.inputSuffixIcon
          ? settings.inputSuffixIcon.match(/^pl_icon_.*/)[0]
          : null;

        /**
         * @type {string} suffixText
         */
        const suffixText = settings.inputSuffixText;

        if (suffixIcon) {
          suffix = document.createElementNS("http://www.w3.org/2000/svg", "svg");
          suffix.classList.add("pl_icon", "pl_input__prefix");
          suffix.setAttribute("role", "img");
          suffix.innerHTML = `<use xlink:href="/assets-static/icons/${suffixIcon}.svg#${suffixIcon}"></use>`;
        } else if (suffixText) {
          suffix = document.createElement("small");
          suffix.classList.add("pl_input__note", "pl_input__suffix");
          suffix.innerText = suffixText;
        }

        return suffix;
      };

      if (settings.inputPrefixIcon || settings.inputPrefixText) {
        [numberInputMinContainer, numberInputMaxContainer].forEach((container) => {
          container.classList.add("pl_input__prefix");
          container.appendChild(buildPrefixElement());
        });
      } else if (settings.inputSuffixIcon || settings.inputSuffixText) {
        [numberInputMinContainer, numberInputMaxContainer].forEach((container) => {
          container.classList.add("pl_input__suffix");
          container.appendChild(buildSuffixElement());
        });
      }

      numberInputWrapper.appendChild(numberInputMinContainer);
      numberInputWrapper.appendChild(numberInputMaxContainer);

      sliderContainer.appendChild(numberInputWrapper);

      /**
       * @type {HTMLElement}
       */
      let inverseLeft;

      /**
       * @type {HTMLElement}
       */
      let range;

      /**
       * @type {HTMLElement}
       */
      let inverseRight;

      /**
       * @type {HTMLElement}
       */
      let thumbMin;

      /**
       * @type {HTMLElement}
       */
      let thumbMax;

      /**
       * @type {HTMLElement}
       */
      let rangeInputMin;

      /**
       * @type {HTMLElement}
       */
      let rangeInputMax;

      if (!isIE11) {
        // Range input: Create DOM elements
        const rangeInputWrapper = document.createElement("div");

        inverseLeft = document.createElement("div");
        const inverseLeftInner = document.createElement("div");
        range = document.createElement("div");
        const rangeInner = document.createElement("div");
        inverseRight = document.createElement("div");
        const inverseRightInner = document.createElement("div");

        rangeInputMin = document.createElement("input");
        rangeInputMax = document.createElement("input");

        thumbMin = document.createElement("span");
        thumbMax = document.createElement("span");

        // Range input: Set CSS classes for elements
        rangeInputWrapper.classList.add("pl_slider__range-wrapper");

        inverseLeft.classList.add("pl_slider__inverse-left");
        inverseLeftInner.classList.add("pl_slider__inverse__inner");
        range.classList.add("pl_slider__range");
        rangeInner.classList.add("pl_slider__range__inner");
        inverseRight.classList.add("pl_slider__inverse-right");
        inverseRightInner.classList.add("pl_slider__inverse__inner");

        rangeInputMin.classList.add("pl_slider__range--min");
        rangeInputMax.classList.add("pl_slider__range--max");

        thumbMin.classList.add("pl_slider__thumb-min");
        thumbMax.classList.add("pl_slider__thumb-max");

        // Range input: Set attributes for elements
        rangeInputMin.setAttribute("type", "range");
        rangeInputMin.setAttribute("tabindex", "0");
        rangeInputMax.setAttribute("type", "range");
        rangeInputMax.setAttribute("tabindex", "0");

        // Range input: Set values for HTML input elements from Slider instance
        rangeInputMin.min = 0;
        rangeInputMin.max = slider.maxPos;
        rangeInputMin.value = slider.minPos;

        rangeInputMax.min = 0;
        rangeInputMax.max = slider.maxPos;
        rangeInputMax.value = slider.maxPos;

        // Range input: Append the elements
        inverseLeft.appendChild(inverseLeftInner);
        range.appendChild(rangeInner);
        inverseRight.appendChild(inverseRightInner);

        rangeInputWrapper.appendChild(inverseLeft);
        rangeInputWrapper.appendChild(range);
        rangeInputWrapper.appendChild(inverseRight);
        rangeInputWrapper.appendChild(rangeInputMin);
        rangeInputWrapper.appendChild(rangeInputMax);
        rangeInputWrapper.appendChild(thumbMin);
        rangeInputWrapper.appendChild(thumbMax);

        sliderContainer.appendChild(rangeInputWrapper);
      }

      /**
       * @param {HTMLInputElement} inputElement
       * @param {number} value
       */
      const setNewValueForRelatedElement = (inputElement, value) => {
        let val;
        let pos;

        if (slider.logarithmic) {
          val = slider.calcLogValue(value).toFixed(0);
          pos = slider.calcLogPosition(value);
        } else {
          val = slider.calcLinValue(value).toFixed(0);
          pos = slider.calcLinPosition(value);
        }

        if (!!rangeInputMin && inputElement.isSameNode(numberInputMin)) {
          if (inputElement.value < slider.minVal) {
            numberInputMin.value = slider.minVal;
            rangeInputMin.value = slider.minPos;
          } else {
            rangeInputMin.value = pos;
          }
        }

        if (!!rangeInputMax && inputElement.isSameNode(numberInputMax)) {
          if (inputElement.value > slider.maxVal) {
            numberInputMax.value = slider.maxVal;
            rangeInputMax.value = slider.maxPos;
          } else {
            rangeInputMax.value = pos;
          }
        }

        if (!!numberInputMin && inputElement.isSameNode(rangeInputMin)) {
          numberInputMin.value = val;
        }

        if (!!numberInputMax && inputElement.isSameNode(rangeInputMax)) {
          numberInputMax.value = val;
        }
      };

      /**
       * @param {HTMLInputElement} rangeElement
       * @returns
       */
      const setRangeElementsToNewPositions = (rangeElement) => {
        if (isIE11) return;

        // Prevent invalid range element positioning
        if (+rangeInputMax.value < +rangeInputMin.value) {
          if (rangeElement.isSameNode(rangeInputMin)) {
            setNewValueForRelatedElement(rangeElement, +rangeInputMax.value);
          } else if (rangeElement.isSameNode(rangeInputMax)) {
            setNewValueForRelatedElement(rangeElement, +rangeInputMin.value);
          }
        } else {
          // Set new range position
          // Scale position based on maxPos
          const scaled_pos = (100 / slider.maxPos) * +rangeElement.value;

          if (rangeElement.isSameNode(rangeInputMin)) {
            inverseLeft.style.width = `${scaled_pos}%`;
            range.style.left = `${scaled_pos}%`;
            thumbMin.style.left = `calc(${scaled_pos}% - (24px*(${scaled_pos} / 100)))`;
            numberInputMin.classList.remove("invalid");
          }

          if (rangeElement.isSameNode(rangeInputMax)) {
            inverseRight.style.width = `${100 - scaled_pos}%`;
            range.style.right = `${100 - scaled_pos}%`;
            thumbMax.style.left = `calc(${scaled_pos}% - (24px * (${scaled_pos} / 100)))`;
            numberInputMax.classList.remove("invalid");
          }
        }
      };

      /**
       * Handle events for number input fields
       *
       * @param {HTMLInputElement} inputElement
       * @returns
       */
      const handleNumberInputChangeEvent = (inputElement) => {
        /**
         * @param {Event} e
         */
        const res = (e) => {
          const { target } = e;

          if (!target.value) {
            target.classList.add("invalid");
          } else {
            setNewValueForRelatedElement(target, +target.value);

            // Stop event when invalid
            if (+numberInputMax.value < +numberInputMin.value) {
              e.preventDefault();
              target.classList.add("invalid");
              return;
            }

            // Move slider thumbs to new positions
            if (inputElement) {
              setRangeElementsToNewPositions(inputElement);
            }

            target.classList.remove("invalid");
          }
        };
        return res;
      };

      /**
       * Handle events for range input fields
       *
       * @param {HTMLInputElement} inputElement
       * @returns
       */
      const handleRangeInputEvent = (e) => {
        const { target } = e;

        setNewValueForRelatedElement(target, +target.value);
        setRangeElementsToNewPositions(target);
      };

      const closerTo = (value) => {
        const diffToMin = Math.abs(value - +rangeInputMin.value);
        const diffToMax = Math.abs(value - +rangeInputMax.value);

        return diffToMin < diffToMax ? rangeInputMin : rangeInputMax;
      };

      const registerEventHandlingForThumbDrag = () => {
        // increase thumb size when dragged
        rangeInputMin.addEventListener("pointerdown", () => {
          thumbMin.style.transform = "scale(calc(32 / 24))";
        });

        rangeInputMax.addEventListener("pointerdown", () => {
          thumbMax.style.transform = "scale(calc(32 / 24))";
        });

        // reset thumb size when released
        rangeInputMin.addEventListener("pointerup", () => {
          thumbMin.style.transform = "initial";
          rangeInputMin.parentNode.insertBefore(rangeInputMax, rangeInputMin);
        });

        rangeInputMax.addEventListener("pointerup", () => {
          thumbMax.style.transform = "initial";
          rangeInputMax.parentNode.insertBefore(rangeInputMin, rangeInputMax);
        });
      };

      const registerEventHandlingForRangeTrackClicks = () => {
        inverseLeft.addEventListener("click", () => {
          rangeInputMin.style.pointerEvents = "none";
        });

        inverseLeft.addEventListener("mouseenter", () => {
          rangeInputMin.addEventListener("mouseleave", () => {
            rangeInputMin.style.pointerEvents = "none";
          });

          rangeInputMin.addEventListener("click", () => {
            rangeInputMin.style.pointerEvents = "none";
          });

          rangeInputMin.style.pointerEvents = "all";

          thumbMax.style.zIndex = 4;
          range.style.zIndex = 4;

          thumbMax.addEventListener("mouseenter", () => {
            rangeInputMin.style.pointerEvents = "none";
            thumbMax.style.zIndex = "initial";
            range.style.zIndex = "initial";
          });
          range.addEventListener("mouseenter", () => {
            rangeInputMin.style.pointerEvents = "none";
            thumbMax.style.zIndex = "initial";
            range.style.zIndex = "initial";
          });
        });

        inverseRight.addEventListener("click", () => {
          rangeInputMax.style.pointerEvents = "none";
        });

        inverseRight.addEventListener("mouseenter", () => {
          rangeInputMax.addEventListener("mouseleave", () => {
            rangeInputMax.style.pointerEvents = "none";
          });

          rangeInputMax.addEventListener("click", () => {
            rangeInputMax.style.pointerEvents = "none";
          });

          rangeInputMax.style.pointerEvents = "all";

          thumbMin.style.zIndex = 4;
          range.style.zIndex = 4;

          thumbMin.addEventListener("mouseenter", () => {
            rangeInputMax.style.pointerEvents = "none";
            thumbMin.style.zIndex = "initial";
            range.style.zIndex = "initial";
          });
          range.addEventListener("mouseenter", () => {
            rangeInputMax.style.pointerEvents = "none";
            thumbMin.style.zIndex = "initial";
            range.style.zIndex = "initial";
          });
        });

        range.addEventListener("click", (e) => {
          const minMaxDiff = +rangeInputMax.value - +rangeInputMin.value;

          const approxVal = Math.round(
            +rangeInputMin.value + parseInt(minMaxDiff * (e.offsetX / range.clientWidth), 10)
          );

          const closerElement = closerTo(approxVal);

          setNewValueForRelatedElement(closerElement, approxVal);

          closerElement.value = approxVal;

          setRangeElementsToNewPositions(closerElement);
        });
      };

      // Register events for the number input elements
      numberInputMin.addEventListener("change", handleNumberInputChangeEvent(rangeInputMin));
      numberInputMax.addEventListener("change", handleNumberInputChangeEvent(rangeInputMax));

      if (!isIE11) {
        // Register events for the range input elements
        rangeInputMin.addEventListener("input", handleRangeInputEvent);
        rangeInputMax.addEventListener("input", handleRangeInputEvent);

        registerEventHandlingForThumbDrag();
        registerEventHandlingForRangeTrackClicks();

        // Dispatch and start
        [rangeInputMin, rangeInputMax].forEach((rangeInput) => {
          rangeInput.dispatchEvent(new Event("input"));
        });
      }

      window.o_global.eventQBus.emit("assets.slider.initialised");
    }

    const sliderHosts = document.querySelectorAll(`${selector} .js-pl_slider`);

    [].forEach.call(
      sliderHosts,
      /**
       * @param {HTMLElement} sliderContainer
       */
      (sliderContainer) => {
        if (sliderContainer.children.length > 0) {
          return;
        }

        settings = { ...defaultSettings, ...parseDataAttributes(sliderContainer) };

        setup(sliderContainer);
      }
    );
  };

  return {
    init,
  };
};

window.o_global.eventQBus.on("assets.slider.init", (selector = "") =>
  window.o_global.pali.slider().init(selector)
);

window.o_global.eventLoader.onAllScriptsExecuted(130, () => {
  window.o_global.eventQBus.emit("assets.slider.init", "body");
});
